/**
 * Loads the application again from a path, dropping everything in memory.
 *
 * For the two moments a screen must not carry what it read: switching business
 * (issue #50), where any figure left on screen belongs to the other books, and
 * finishing a signup that signed somebody in.
 *
 * A module of its own so a test can replace it: jsdom implements no navigation,
 * and `window.location.assign` cannot be stubbed there.
 */
export function reloadTo(path: string): void {
  window.location.assign(path);
}
